import React from 'react';
import { Handle, Position } from 'reactflow';

const operatorOptions = [
  { value: 'crosses_above', label: 'Crosses Above' },
  { value: 'crosses_below', label: 'Crosses Below' },
  { value: 'greater_than', label: 'Greater Than' },
  { value: 'less_than', label: 'Less Than' },
  { value: 'equals', label: 'Equals' },
];

export default function ConditionNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #d29922',
      background: 'var(--card)',
      minWidth: 180,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <Handle type="target" position={Position.Left} id="left" style={{ top: '30%', background: '#d29922' }} />
      <Handle type="target" position={Position.Left} id="right" style={{ top: '70%', background: '#d29922' }} />
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#d29922' }}>
        ⚖️ Condition
      </div>
      <div style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 4 }}>
        Left ● — top &nbsp; | &nbsp; Right ● — bottom
      </div>
      <select
        value={data.operator || 'crosses_above'}
        onChange={(e) => onChange('operator', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        {operatorOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#d29922' }} />
    </div>
  );
}
